<template>
  <v-container class="max-width-1200">

    <v-row class="justify-center">
      <v-col>
        <v-row>
          <v-col class="pb-0 headline text-uppercase">
            {{ $t('common.about') }}
          </v-col>
        </v-row>
        <v-row>
          <v-col class="display-1">
            {{ $t('rubicon.about.subtitle.01')}}<br>
            <span class="title">{{ $t('rubicon.about.example')}}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-justify">
            {{ $t('rubicon.about.text.01')}}<br>
            {{ $t('rubicon.about.text.02')}}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'RubiconAbout',
    extends: DataComponentBase,

    data: () => ({

    }),

    methods: {

    },
  }
</script>
